class StandInAvatar extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	render() {
		var dims = { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight };
		var src = require("owls/default-owl-10.png");

		return (
			<img src={ src } alt="standInAvatar" className="adminAvatar" style={ dims } />
		)
	}
};

StandInAvatar.propTypes = StrictPropTypes({
	maxWidth: PropTypes.number,
	maxHeight: PropTypes.number
});

module.exports = StandInAvatar;


// WEBPACK FOOTER //
// ./modules/components/avatars/StandInAvatar.js